module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_footer_hapista-f4c3f46e7c452d96c220b4acb67568bf.svg";